import { render, staticRenderFns } from "./LevModal.vue?vue&type=template&id=9fc9f9ca&scoped=true"
import script from "./LevModal.vue?vue&type=script&lang=js"
export * from "./LevModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc9f9ca",
  null
  
)

export default component.exports